import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 24px;
  width: 100%;
  max-width: 560px;
  max-height: min(86vh, 720px);
  overflow: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);
  border-radius: 24px 24px 0 0;
  
  h3 {
    margin: 0;
    color: white;
    font-size: 16px;
    font-weight: 700;
  }
  
  p {
    margin: 6px 0 0 0;
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
`;

export const TextArea = styled.textarea`
  box-sizing: border-box;
  display: block;
  width: 100%;
  min-height: 140px;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  
  &:focus {
    outline: none;
    border-color: #0891b2;
  }
`;

export const InfoText = styled.p`
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #64748b;
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid #e2e8f0;
`;

export const FooterButton = styled.button<{ variant?: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  
  ${props => props.variant === 'primary' ? `
    background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);
    border: none;
    color: white;
  ` : `
    background: white;
    border: 2px solid #e2e8f0;
    color: #475569;
    
    &:hover {
      border-color: #0891b2;
      color: #0891b2;
    }
  `}
`;
